export const START_TRIAL_REQUEST = 'START_TRIAL_REQUEST';
export const START_TRIAL_SUCCESS = 'START_TRIAL_SUCCESS';
export const START_TRIAL_FAILURE = 'START_TRIAL_FAILURE';
export const START_TRIAL_RESET = 'START_TRIAL_RESET';
